import AppConstants from '../config/app.constants';

let TransactionService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/transaction`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/transaction/create`, data)
            .then((res) => {
                return res.data
            })
    }

    let transactionHistory = (trackingId, limit, offset) => {
        return $http
            .post(AppConstants.api + `/transaction/transaction-history`, {
                trackingId,
                limit,
                offset
            })
            .then((res) => {
                return res.data
            })
    }

    let currentContent = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/transaction/current-content`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let exportNoPickupTransactionHistory = (locationId, startDate, endDate, timezone, sortColumn, sortASC) => {
        return $http
            .post(AppConstants.api + `/transaction/export-no-pickup-transaction-history`, {
                locationId, startDate, endDate, timezone, sortColumn, sortASC
            })
            .then((res) => {
                return res.data
            })
    }

    let printNoPickupTransactionHistory = (locationId, startDate, endDate, timezone, sortColumn, sortASC) => {
        return $http
            .get(AppConstants.api + `/transaction/print-no-pickup-transaction-history`, {
                params: { locationId, startDate, endDate, timezone, sortColumn, sortASC }
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        all,
        create,
        transactionHistory,
        currentContent,
        exportNoPickupTransactionHistory,
        printNoPickupTransactionHistory
    };

};

TransactionService.$inject = ['$http', '$q']

export default TransactionService;



// WEBPACK FOOTER //
// ./client/app/services/transaction.service.js